export const ObjectMixin = {

  getObjectDifference: function (obj1, obj2) {
    const o1 = JSON.parse(JSON.stringify(obj1));
    const o2 = JSON.parse(JSON.stringify(obj2));
    let diff = Object.keys(o2).reduce((diff, key) => {
      const key1 = o1[key] ? o1[key].toString() : "";
      const key2 = o2[key] ? o2[key].toString() : "";
      if (key1 === key2) return diff;
      return {
        ...diff,
        [key]: o2[key]
      }
    }, {});
    return diff;
  },

  convertObjectKeyValue: function (obj, old) {
    return Object.keys(obj).map(a => a === 'DATUM' ? ({
      fieldname: a,
      newvalue: this.formatDateSql(obj[a]),
      oldvalue: this.formatDateSql(old[a])
    }) : ({fieldname: a, newvalue: obj[a], oldvalue: old[a]}));
  },

  formatDateSql: function (date) {
    return `${date.split('/')[2]}/${date.split('/')[1]}/${date.split('/')[0]}`;
  },

  formatDateSqlString: function (date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const days = date.getDate();
    return `${year}/${month > 10 ? month : '0' + month}/${days > 10 ? days : '0' + days}`;
  },

  formatDateString: function (date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const days = date.getDate();
    return `${days > 10 ? days : '0' + days}/${month > 10 ? month : '0' + month}/${year}`;
  }
};
